import { type DietaryRestrictionsText } from '@hungryroot/dietary-restrictions';
import { type ProductV1 as Product } from '@hungryroot/rest';
import {
  AddRemoveBtn as AddRemoveButton,
  ButtonWithPoints,
  PlacementVariant,
  VisualVariant,
} from '../../../pages/customize/components/CartAddRemoveButton/AddRemoveButton';
import { getProductCount } from '../../cart/query';
import { useCustomization } from '../../CustomizationProvider/CustomizationProvider';
interface Props {
  product: Product;
  onRemoveClick: () => void;
  onAddClick: () => void;
  dietaryProductIngredients: DietaryRestrictionsText[];
}

export function PDPAddRemoveButton(props: Props) {
  const { product, onRemoveClick, onAddClick, dietaryProductIngredients } =
    props;
  const customization = useCustomization();

  if (!('cart' in customization)) {
    return null;
  }

  const { cart } = customization;

  const productCanBeAdded =
    'productCanBeAdded' in customization
      ? customization.productCanBeAdded
      : () => false;
  const cartCount = getProductCount(cart, product.id);
  const itemToBeAddedPoints = product.points;

  if (!product.is_merchandized) {
    return (
      <div className="add-remove-btn-container">
        <ButtonWithPoints
          // if using VisualVariant.Light, which is always
          isLight={true}
          itemToBeAdded={{
            id: product.id,
            points: itemToBeAddedPoints,
          }}
          label="Out of stock"
          data-testid={`out-of-stock-button-${product.id}`}
          disabled={true}
        />
      </div>
    );
  }

  const handleOnAddClick = () => {
    'mutations' in customization &&
      customization.mutations.addProduct({
        product,
        dietaryProductIngredients,
        onSuccess: onAddClick,
        location: 'pdp',
      });
  };

  return (
    <>
      <AddRemoveButton
        visualVariant={VisualVariant.Light}
        useCartResult={customization}
        disabled={!productCanBeAdded(product)}
        onAddClick={handleOnAddClick}
        onRemoveClick={() => {
          'mutations' in customization &&
            customization.mutations.removeProduct(product);
          onRemoveClick && onRemoveClick();
        }}
        item={{
          id: product.id,
          points: itemToBeAddedPoints.toString(),
        }}
        count={cartCount}
        placementVariant={PlacementVariant.Modal}
        onClick={() => {
          handleOnAddClick();
        }}
      />
    </>
  );
}
